import { CheckCircle2 } from "lucide-react";

type CreateSalesOrderSaveToastProps = {
  visible: boolean;
};

export function CreateSalesOrderSaveToast({ visible }: CreateSalesOrderSaveToastProps) {
  if (!visible) {
    return null;
  }

  return (
    <div
      className="pointer-events-none fixed inset-x-0 top-4 z-[110] flex justify-center px-4"
      aria-live="polite"
      role="status"
    >
      <div className="flex items-center gap-2 rounded-md border border-emerald-200 bg-emerald-50 px-4 py-2.5 text-sm font-medium text-emerald-950 shadow-lg">
        <CheckCircle2 className="h-4 w-4 text-emerald-700" aria-hidden="true" />
        Changes Saved
      </div>
    </div>
  );
}
